const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    height: '80px',
    padding: '0 24px',
}

const cardStyle = {
    backgroundColor: '#ffffff',
    padding: 16,
};

const buttonIconStyle = {
    fontSize: 18
}

const tableIconStyle = {
    fontSize: 25,
    cursor: 'pointer'
}


export {headerStyle, cardStyle, buttonIconStyle, tableIconStyle};